import $ from 'jquery';
import TicketSelector from '../../../events/detail/TicketSelector';
import { loadModal } from '../../../AsyncLoader';

const defaults = {
  modalBtnCloseLabel: 'Close',
};

class PackageDetail {
  constructor(formSelector, packageDetailConfig, ticketSelectorOptions) {
    this.config = Object.assign({}, defaults, packageDetailConfig);

    this.ticketSelector = new TicketSelector(formSelector, ticketSelectorOptions);

    this.initMoreInfoButtons();
  }

  async initMoreInfoButtons() {
    const $btns = $('.tn-package-perf__btn-more-info');
    if ($btns.length === 0) {
      return;
    }

    const Modal = await loadModal();

    $btns.show();
    $btns.on('click', (event) => {
      const { pkgPerfId, pkgPerfTitle } = event.currentTarget.dataset;
      const { modalBtnCloseLabel } = this.config;
      const templateEl = document.querySelector(`#tn-pkg-perf-desc-template-${pkgPerfId}`);
      const html = templateEl.innerHTML;

      Modal.alert({
        title: pkgPerfTitle,
        bodyContents: html,
        labelBtnAccept: modalBtnCloseLabel,
        returnFocusTo: event.currentTarget,
      });
    });
  }
}

window.tnew.PackageDetail = PackageDetail;

export default PackageDetail;



// WEBPACK FOOTER //
// ./V7/packages/fixed/detail/PackageDetail.js